export const ROLE_CLAIM =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" as const;
export interface TokenPayload {
  aud: string;
  fullname: string;
  email: string;
  exp: number;
  iss: string;
  tenant: string;
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string;
  username: string;
  userId: string;
  emailConfirmed: string;
  isTrialAccount: boolean;
  trialExpiration: Date;
}

export function getClaim<T extends keyof TokenPayload>(
  token: TokenPayload,
  claim: T
): TokenPayload[T] {
  return token[claim];
}
